import { Button } from '@synoptic/ui-kit/button/button.js';
import { ArrowUpRightIcon } from '@synoptic/ui-kit/icons/react/arrow-up-right.js';
import { useNavigate } from 'react-router';
import { StripePriceFragmentFragment } from '@/__generated__/graphql';
import { Stream } from '@/__generated__/schema-types.ts';
import { paths } from '@/routes-utils/paths.ts';
import { getMonthlyPrice } from '@/utils/paid-data.ts';
import {
  HomeCardNameAndDescription,
  HomeStreamCardCategoryBadge,
  HomeStreamCardFeaturedBadge,
  HomeStreamCardFollowersBlock,
  HomeStreamCardPriceTag,
} from '../streams-section/home-stream-card.tsx';
import {
  homeStreamCardMiniHeader,
  homeViewDetailsButton,
} from '../streams-section/home-streams-section.css.ts';
import {
  authorStreamCard,
  authorStreamCardDetails,
  homeStreamCardMiniFooter,
} from './home-authors-section.css.ts';

export const HomeAuthorStreamCard = ({ stream }: { stream: Stream }) => {
  const navigate = useNavigate();
  return (
    <div className={authorStreamCard}>
      <header className={homeStreamCardMiniHeader}>
        <HomeStreamCardCategoryBadge category={stream.streamCategory} />
        <HomeStreamCardPriceTag
          price={getMonthlyPrice(
            stream.paidData as StripePriceFragmentFragment[] | null | undefined,
          )}
        />
      </header>
      <main>
        <HomeCardNameAndDescription
          name={stream.name}
          description={stream.description}
          size="small"
        />
      </main>
      <footer className={homeStreamCardMiniFooter}>
        <div className={authorStreamCardDetails}>
          <HomeStreamCardFollowersBlock
            followersCount={stream.followersCount}
          />
          {stream.isFeatured && <HomeStreamCardFeaturedBadge short />}
        </div>
        <Button
          variant="outline"
          size="small"
          fullWidth
          className={homeViewDetailsButton}
          onClick={() => {
            navigate(paths.makeStream(stream.id));
          }}
        >
          View Stream <ArrowUpRightIcon />
        </Button>
      </footer>
    </div>
  );
};
